// Тялото на въпрос преди необратимо действие: какво ТОЧНО ще направи
// (редовете; предупрежденията — в червено), а най-отдолу самият въпрос
// „Сигурни ли сте…?". Голото „Сигурни ли сте?" не казва какво ще излезе от
// касата и кой връща парите — операторът научаваше чак след натискането.
// Ползват го „Сторнирай всичко" / „Възстанови" в „История на операциите"
// (`billActionConsequences.ts`) и „Анулирай" на фактура.

import { useTranslation } from "react-i18next";

export type Consequence = {
  text: string;
  /** Нещо, което операторът трябва да направи сам (напр. върнатите пари). */
  warn?: boolean;
};

type Props = {
  lines: Consequence[];
  question: string;
};

export const ConfirmConsequences = ({ lines, question }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2.5">
      <span className="text-[12.5px] font-semibold text-muted">
        {t("confirmConsequences.intro")}
      </span>
      <ul className="m-0 flex list-disc flex-col gap-1.5 pl-5">
        {lines.map((line) => (
          <li
            key={line.text}
            className={line.warn ? "font-semibold text-danger-ink" : "text-ink"}
          >
            {line.text}
          </li>
        ))}
      </ul>
      <p className="m-0 font-semibold text-ink">{question}</p>
    </div>
  );
};
